import { render, staticRenderFns } from "./iconSecurity.vue?vue&type=template&id=68469c1e&scoped=true"
import script from "./iconSecurity.vue?vue&type=script&lang=js"
export * from "./iconSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68469c1e",
  null
  
)

export default component.exports